import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BRAND } from "../../data/collection";
import { IG_DM, buildGeneralMessage, waLink } from "../../lib/order";
import { WhatsAppMark, ReplyNudge } from "./QuickChat";
import { Reveal } from "./Reveal";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative overflow-hidden bg-[#050505] text-white"
    >
      <div className="kln-noise" />

      {/* Order CTA band */}
      <div className="relative border-t border-white/10">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-20 py-20 md:py-28 text-center">
          <Reveal>
            <p className="font-body text-[11px] uppercase tracking-[0.4em] text-white/40">
              To Order
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mx-auto mt-6 max-w-3xl font-serif-editorial text-4xl md:text-6xl font-light italic leading-[1.05] text-white/90">
              No carts, no checkout. Just tell us your favourite piece and your
              size — we&apos;ll take it from there.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
              <a
                data-testid="footer-order-whatsapp"
                href={waLink(buildGeneralMessage())}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-3 rounded-full bg-[#25D366] px-9 py-5 font-body text-[12px] uppercase tracking-[0.24em] text-white transition-transform duration-300 hover:brightness-110 hover:translate-y-[-1px]"
              >
                <WhatsAppMark className="h-4 w-4" />
                WhatsApp us
              </a>
              <a
                data-testid="footer-order-dm"
                href={IG_DM}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-3 rounded-full bg-white px-9 py-5 font-body text-[12px] uppercase tracking-[0.24em] text-black transition-colors duration-300 hover:bg-[var(--kln-gold)]"
              >
                Instagram DM
                <ArrowUpRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.5} />
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <ReplyNudge testid="footer-wa-nudge" className="mt-5" />
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 font-body text-[11px] uppercase tracking-[0.25em] text-white/40">
              {BRAND.whatsappNumber} · {BRAND.instagramHandle}
            </p>
          </Reveal>
        </div>
      </div>

      {/* Giant wordmark */}
      <div className="relative border-t border-white/10 px-6 pt-16 md:px-12">
        <motion.img
          src="/keilani-logo-white.png"
          alt="Keilani Clothing"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 0.9, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
          className="mx-auto w-full max-w-5xl"
        />
      </div>

      {/* meta row */}
      <div className="relative mx-auto flex max-w-[1500px] flex-col items-center justify-between gap-4 px-6 py-10 font-body text-[10px] uppercase tracking-[0.28em] text-white/35 md:flex-row md:px-12">
        <span>© {new Date().getFullYear()} Keilani Clothing</span>
        <span>Shipping Worldwide · Free Shipping All Over India</span>
        <span>Onam Collection · Kerala</span>
      </div>
    </footer>
  );
}
